<picture class="icon-alert">
  <em class="icon-alerta"></em>
</picture>

<h2 mat-dialog-title>
  Tuvimos un inconveniente con la carga de tus documentos.
</h2>

<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <p class="copy">
      <strong>No te preocupes</strong>, puedes continuar con la solicitud y uno
      de nuestros asesores te contactará para que hagas el envío.
    </p>
  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <button
    mat-dialog-close
    class="btn btn-degraded blue"
    (click)="redirect()"
    type="button"
  >
    Entendido
  </button>
</div>
